/** Interpolate rich UI values without putting grammatical order in components. */
export function interpolateParts<T>(template: string, values: Record<string, T>): (string | T)[] {
  return template.split(/(\{[A-Za-z_][A-Za-z0-9_]*\})/).map((part) => {
    const key = part.startsWith("{") && part.endsWith("}") ? part.slice(1, -1) : ""
    return key && Object.hasOwn(values, key) ? values[key]! : part
  })
}
